import { createFileRoute } from "@tanstack/react-router";
import AdminStartupLibrary from "@/pages/AdminStartupLibrary";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/startup-library/")({
  component: () => (
    <RoleGate allow={['staff']} area="MavenWERX Startup Library"><AdminStartupLibrary /></RoleGate>
  ),
});
